export default () => ({
    tabSelected: 0,
    tabId: "tabs",
    initialized: false,
    init() {
        this.tabRepositionMarker(this.$refs.tabButtons.firstElementChild);
        this.initialized = true;
    },
    tabButtonActive(tabButton) {
        return this.tabSelected === tabButton.id.replace(this.tabId + "-", "");
    },
    tabButtonClicked(tabButton, index) {
        this.tabSelected = index;
        this.tabRepositionMarker(tabButton);
    },
    tabRepositionMarker(tabButton) {
        this.$refs.tabMarker.style.width = tabButton.offsetWidth + "px";
        this.$refs.tabMarker.style.height = tabButton.offsetHeight + "px";
        this.$refs.tabMarker.style.left = tabButton.offsetLeft + "px";
    }
})